import selectUserChoiceValues from "./selectUserChoiceValues";
import selectSelectedProduct from "./selectSelectedProduct";
import { getIsOutOfStock } from "utils";

export default function selectIsOutOfStock(state) {
  const selectedProduct = selectSelectedProduct(state);
  const userChoiceValues = selectUserChoiceValues(state);

  return getIsOutOfStock({
    outOfStockVariations: selectedProduct.outOfStockVariations,
    userChoiceValues,
  });
}
